import { useMemo } from 'react';
import { useSettings } from '@wix/tpa-settings/react';

import { useOnlineOrdersStorage } from '../../storage';
import { useGetLayoutSize } from '../../../../components-shared/LayoutSizeProvider';
import settingsParams from '../../settingsParams';
import {
  parseMenuOrder,
  getOrderedMenus,
  applyMenuEditorSettings,
} from '../../../../utils/menuEditorSettings';

export const useHooks = () => {
  const { layoutSize } = useGetLayoutSize();
  const { menus, currentOperation, itemMap } = useOnlineOrdersStorage();
  const settings = useSettings();

  const sortedMenuIds = settings.get(settingsParams.sortedMenuIds);
  const showUnavailableOptions = settings.get(
    settingsParams.showUnavailableOptions,
  );
  const showUnavailableAndExpiredLast = settings.get(
    settingsParams.showUnavailableAndExpiredLast,
  );
  const showMenuDescription = settings.get(settingsParams.showMenuDescription);
  const showMenuDivider = settings.get(settingsParams.showMenuDivider);

  const processedMenus = useMemo(() => {
    const menuOrder = parseMenuOrder(sortedMenuIds);
    const ordered = getOrderedMenus(
      menus,
      menuOrder[currentOperation?.id ?? ''],
    );

    return applyMenuEditorSettings(ordered, itemMap, {
      showUnavailableOptions,
      showUnavailableAndExpiredLast,
    });
  }, [
    menus,
    currentOperation?.id,
    sortedMenuIds,
    itemMap,
    showUnavailableOptions,
    showUnavailableAndExpiredLast,
  ]);

  return {
    menus: processedMenus,
    layoutSize,
    showMenuDescription,
    showMenuDivider,
  };
};
